import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '@Theme';
import { CssSelectors } from '@Styles/styles';

const { spacing, colors, typography } = THEME;

const indicator = (color: string) =>
	CssSelectors.allChildren({ height: 8, width: 8, borderRadius: '50%', backgroundColor: color }, '.indicator');

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		borderRadius: THEME.common.borderRadius,
		color: colors.text.main,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: typography.fontSizes.xs,
		gap: spacing.xs,
		marginTop: SPACE[4],
		padding: `${spacing.xs}px ${spacing.sm}px`,
	},
	containerHealthy: {
		backgroundColor: colors.success.light,
		...indicator(colors.success.dark),
	},
	containerUnhealthy: {
		backgroundColor: colors.danger.light,
		...indicator(colors.danger.dark),
	},
	containerNeutral: {
		backgroundColor: colors.hover.light,
		...indicator(colors.hover.dark),
	},
	title: {
		fontWeight: typography.fontWeights.bold,
	},
	metric: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.xs,
	},
	separator: {
		color: colors.text.light,
	},
	value: {
		fontWeight: typography.fontWeights.bold,
	},
	infoIcon: {
		alignItems: 'center',
		display: 'flex',
		marginLeft: spacing.xs,
	},
	tooltip: {
		maxWidth: 420,
		whiteSpace: 'normal',
	},
	// The counts read as one unit, so they get their own line rather than wrapping a stray "of N"
	// onto the next; the width above is what lets them fit.
	tooltipCounts: {
		whiteSpace: 'nowrap',
	},
	tooltipDisclaimer: {
		color: colors.text.light,
		marginTop: spacing.xs,
	},
});
